import type { ReactNode } from "react";
import { Check, X } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/** Stops click propagation: it sits in clickable rows, and reaching for the tooltip must not navigate. */
export function PresenceIndicator({
  present,
  tooltip,
  label,
}: {
  present: boolean;
  /** Detail shown on hover when present (e.g. the address lines). */
  tooltip?: ReactNode;
  label: string;
}) {
  const icon = present ? (
    <Check className="size-4 text-emerald-600" aria-hidden />
  ) : (
    <X className="size-4 text-muted-foreground/40" aria-hidden />
  );

  if (!present || !tooltip) {
    return (
      <span className="inline-flex" role="img" aria-label={`${label}: ${present ? "yes" : "no"}`}>
        {icon}
      </span>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex cursor-help"
            role="img"
            aria-label={`${label}: yes`}
            onClick={(e) => e.stopPropagation()}
          >
            {icon}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-left whitespace-pre-line">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
